import React from 'react';

import { IJob } from '@src/models';
import { Modal, ModalProps, BaseBox, Flex, Text, BaseLink, Button } from 'src/kit';

type ApplicationConfirmationModalProps = ModalProps & {
  onConfirm: () => void;
  job: IJob;
};

export function ApplicationConfirmationModal({ job, onConfirm, onClose }: ApplicationConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal onClose={onClose} py={0} px={0}>
      <Flex alignItems="center" justifyContent="center" bg="primary" color="white" fontSize={20} height="52px">
        Agree to {job.company.name} Privacy policy
      </Flex>
      <BaseBox p="25px 40px" color="textSecondary">
        <Text as="p" mb={10}>
          {`By clicking Continue, you agree to ${job.company.name} `}
          <BaseLink href={job.company.disclaimer_url} openInNewTab variant="auth" mb={15} display="inline-block">
            Privacy policy
          </BaseLink>
          .
        </Text>
        <Text as="p" mb={10}>
          Your application will only be submitted once you have confirmed it there. Good luck in the process!
        </Text>
        <Flex justifyContent="flex-end">
          <Button onClick={handleConfirm} variant="primary" size="md">
            Continue
          </Button>
        </Flex>
      </BaseBox>
    </Modal>
  );
}
